export default "__VITE_ASSET__7utFjROq__"